// i18n.js 
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "locales/en/translation.json";
import translationFA from "locales/fa/translation.json";
import translationAR from "locales/ar/translation.json";
const storedLanguage = localStorage.getItem('language') || 'fa'; // default to 'fa'
const resources = {
    en: { translation: translationEN },
    fa: { translation: translationFA },
    ar: { translation: translationAR },
};
i18n.use(initReactI18next).init({
    resources,
    lng: storedLanguage,
    fallbackLng: "fa",
    interpolation: { escapeValue: false },
    // React already does escaping
});
i18n.on('languageChanged', (language) => {
    localStorage.setItem('language', language); // store selected language 
});
export default i18n;